<!--赖传峰-->
<!--2021/12/15-->
<!--eslint-disable max-len-->
<template>
  <PathSlot v-bind="props">
    <path
      :fill="props.color"
      clip-rule="evenodd"
      d="M9.22205 4.31694C9.56904 3.88727 10.1987 3.82025 10.6283 4.16724C11.0249 4.48755 11.1125 5.04866 10.8508 5.47103L10.778 5.57351L6.74006 10.5735C6.41823 10.972 5.85371 11.0583 5.43106 10.7927L5.32858 10.719L2.36653 8.2938C1.9392 7.94393 1.87641 7.31389 2.22629 6.88656C2.54925 6.4921 3.11093 6.40826 3.53154 6.67288L3.63353 6.74632L5.81603 8.53299L9.22205 4.31694ZM14 3.99999C13.448 3.99999 13 4.44771 13 4.99999C13 5.55227 13.448 5.99999 14 5.99999H21C21.552 5.99999 22 5.55227 22 4.99999C22 4.44771 21.552 3.99999 21 3.99999H14ZM14 8.99999C13.448 8.99999 13 9.44771 13 9.99999C13 10.5523 13.448 11 14 11H21C21.552 11 22 10.5523 22 9.99999C22 9.44771 21.552 8.99999 21 8.99999H14ZM14 14C13.448 14 13 14.4477 13 15C13 15.5523 13.448 16 14 16H21C21.552 16 22 15.5523 22 15C22 14.4477 21.552 14 21 14H14ZM13 20C13 19.4477 13.448 19 14 19H21C21.552 19 22 19.4477 22 20C22 20.5523 21.552 21 21 21H14C13.448 21 13 20.5523 13 20ZM10.6283 14.1672C10.1987 13.8202 9.56904 13.8873 9.22205 14.3169L5.81603 18.533L3.63353 16.7463L3.53154 16.6729C3.11093 16.4083 2.54925 16.4921 2.22629 16.8866C1.87641 17.3139 1.9392 17.9439 2.36653 18.2938L5.32858 20.719L5.43106 20.7927C5.85371 21.0583 6.41823 20.972 6.74006 20.5735L10.778 15.5735L10.8508 15.471C11.1125 15.0487 11.0249 14.4875 10.6283 14.1672Z"
      fill-rule="evenodd"
    />
  </PathSlot>
</template>

<script
  lang="ts"
  setup
>
import iconPropsType from './iconPropsType'
import PathSlot from './PathSlot.vue'

const props = defineProps(iconPropsType)
</script>
